exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1uFAv{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._2B6Dt{font-weight:600;color:inherit;text-decoration:none}._2O5JS{position:absolute;top:100%;right:0;padding:10px 8px 8px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3iQnl{vertical-align:text-bottom}._2xW05{vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_1uFAv",
	"content": "_2B6Dt",
	"popup": "_2O5JS",
	"icon": "_3iQnl",
	"title": "_2xW05"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Balance/Balance.css
// module id = 1372
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46